import { isAdminSession, logoutAdmin } from "@app/lib/admin-session";
import { useState } from "react";

import AdminDashboard from "./admin-dashboard";
import AdminLogin from "./admin-login";

export default function AdminConsolePage() {
  const [authed, setAuthed] = useState(isAdminSession());

  if (!authed) return <AdminLogin onLoggedIn={() => setAuthed(true)} />;

  return (
    <AdminDashboard
      onLogout={() => {
        logoutAdmin();
        setAuthed(false);
      }}
    />
  );
}
